import React from 'react'
import FormatCurrency from '../../helpers/FormatCurrency'
import { displayImage } from '../../helpers/config'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { CiTrash } from 'react-icons/ci'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../../helpers/Axios'

function CartItemRow({ item = {}, i }) {


    const queryClients = useQueryClient()


    // Change Quantity

    const { mutate: change } = useMutation({
        mutationFn: async (formData) => {
            return apiClient.post('/cart/change', formData)
        },
        onSuccess: () => {
            queryClients.invalidateQueries(['cart'])
        }
    })

    const handleQuantityChangle = (id, target) => {
        change({ id, target })
    }



    // Delete Item
    const { mutate: deleteItem } = useMutation({
        mutationFn: async (id) => {
            return apiClient.delete('/cart/delete', { params: { id: id } })
        },
        onSuccess: () => {
            queryClients.invalidateQueries(['cart'])
        }
    })

    const handleDelete = (id) => {
        deleteItem(id)
    }



    return (
        <tr key={i}>

            <td className='p-5 border'>
                <div className="flex gap-5 items-center">
                    {/* img */}
                    <div className=''>
                        <img src={displayImage(JSON.parse(item?.product?.images)[0])} alt="" className='w-28' />
                    </div>

                    {/* Details */}
                    <div className="w-full relative space-y-0.5">
                        <h2 className='capitalize'>{item?.product?.name}</h2>
                        <p className="text-gray-500 text-sm capitalize">
                            {item?.variant?.size} {item?.variant?.color}
                        </p>
                        {/* Customise */}
                        {item?.product?.customable && (
                            <p className="text-gray-500 text-sm capitalize flex gap-1">
                                Customisation: <FormatCurrency amount={item?.customisation_price * item?.quantity} />
                            </p>
                        )}
                        <p className="text-gray-500 text-sm">
                            <FormatCurrency amount={item?.price - item?.discount} />
                        </p>
                    </div>
                </div>
            </td>

            <td className='p-5 border'>
                {/* Quantity */}
                <div className="w-28 rounded mt-2 p-2.5 bg-gray-100 border flex items-center justify-between">
                    <button onClick={() => handleQuantityChangle(item?.id, 'minus')}><AiOutlineMinus size={11} /></button>
                    <input type="text" value={item?.quantity} disabled onChange={() => { }}
                        className='outline-none text-sm bg-transparent w-5 text-center'
                    />
                    <button onClick={() => handleQuantityChangle(item?.id, 'plus')}><AiOutlinePlus size={11} /></button>
                </div>
            </td>


            <td className='p-5 border'>
                <FormatCurrency amount={item?.line_total} />
            </td>


            <td className='p-5 border'>
                {/*Delete Trash  */}
                <button onClick={() => handleDelete(item?.id)} className='text-red-700'>
                    <CiTrash />
                </button>
            </td>

        </tr>
    )
}

export default CartItemRow